interface SiteElementFilterArrayInlineRendererConfig {
    isSingleSelect: boolean;
}

class SiteElementFilterArrayInlineRenderer
    extends QueryElement<HTMLElement>
    implements ISiteElementFilterRenderer, ISiteElementCheckItem {
    
    private readonly _filter: SiteElementFilterArray;
    private readonly _value: ISiteFilterItem;
    private readonly _config: SiteElementFilterArrayInlineRendererConfig;
    private readonly _type: SiteElementFilterArrayTypes;
    
    constructor(filter: SiteElementFilterArray, value: ISiteFilterItem, type: SiteElementFilterArrayTypes) {
        super(document.createElement("DIV"));

        this._filter = filter;
        this._value = value;
        this._type = type;
        this._config = this._filter.getConfig<SiteElementFilterArrayInlineRendererConfig>({
            isSingleSelect: false
        });

        this.addClass("element-filter-inline");

        this.append(this.renderChilds(value.items));
    }

    addValue(value: ISiteFilterItemValue): void {
        if (this._config.isSingleSelect) {
            this._filter.removeValues();
            this.query(".element-filter-checkitem")
                .all<SiteElementCheckItem, any>(a => a.makeInactive());
        }
        
        this._filter.addValue(value.filterValue);
        this._filter.updateFilterModel(false);
    }
    removeValue(value: ISiteFilterItemValue): void {
        this._filter.removeValue(value.filterValue);
        this._filter.updateFilterModel(false);
    }
    containsValue(value: ISiteFilterItemValue): boolean {
        return this._filter.containsValue(value.filterValue);
    }

    renderChilds(values: ISiteFilterItemValue[]) {
        let container = QueryElement.QueryElement("UL");
        
        for(let item of values) {
            let containerItem = QueryElement.QueryElement("LI");

            switch(this._type)
            {
                default:
                    new SiteElementCheckItem(this, item)
                        .appendTo(containerItem);
                    break;
                case  "color":
                    new SiteElementCheckColorItem(this, item as ISiteFilterColorItemValue)
                        .appendTo(containerItem);
                    break;
            }
            
            if (item.childs != null) {
                this.renderChilds(item.childs)
                    .appendTo(containerItem);
            }

            container.append(containerItem);
        }

        return container;
    }

    getState() {
        return null;
    }
}
